export default __webpack_public_path__ + "570324f763419e5f30c0163b1642e0c2.png";